import React, { useState } from 'react';
import { DialogContainer } from 'react-md';
import CommonTextField from './Textfield/CommonTextField';
import { changePassword } from '../../api/authAPI';
import { message } from 'antd';
import { useDispatch } from 'react-redux';
import { showNotification } from '../SpaceProfile/SubComponents/Common';
import { removeAuthDetails } from '../../redux/auth/authAction';

const MandatoryChangePasswordModal = ({ visible, onClose }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const handleSubmit = async () => {
        if (!currentPassword || !newPassword || !confirmPassword) {
            message.error('Please fill in all fields');
            return;
        }

        if (newPassword !== confirmPassword) {
            message.error('Passwords do not match');
            return;
        }

        setLoading(true);
        try {
            const payload = {
                currentPassword,
                newPassword,
                confirmPassword
            };
            await changePassword(payload);
            
            showNotification('Password changed successfully! Please log in with your new password.');
            
            dispatch(removeAuthDetails());
            onClose();
        } catch (error) {
            console.error('Error changing password:', error);
            message.error((error.response && error.response.data && error.response.data.message) || 'Failed to change password. Please check your current password.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <DialogContainer
            id="mandatory-change-password-modal"
            className="signup-popup full-width-popup"
            visible={visible}
            onHide={() => {}} // Disable closing by clicking outside
            modal
        >
            <div className="signup-popup-wrap">
                <div className="header">
                    <div className="left-wrap"></div>
                    <div className="title-text">Mandatory Password Change</div>
                    <div className="right-wrap"></div>
                </div>
                <div className="content custom-content">
                    <div className="sub-text" style={{ textAlign: 'center', color: '#777', fontSize: '14px', marginBottom: '20px' }}>
                        Your account was created with a temporary password. For security reasons, you must change it before proceeding.
                    </div>
                    <div className="input-wrap">
                        <div className="md-grid">
                            <CommonTextField
                                label="Temporary Password"
                                type="password"
                                lineDirection="right"
                                className="floating-input"
                                value={currentPassword}
                                onChange={(val) => setCurrentPassword(val)}
                            />
                        </div>
                        <div className="md-grid">
                            <CommonTextField
                                label="New Password"
                                type="password"
                                lineDirection="right"
                                className="floating-input"
                                value={newPassword}
                                onChange={(val) => setNewPassword(val)}
                            />
                        </div>
                        <div className="md-grid">
                            <CommonTextField
                                label="Confirm New Password"
                                type="password"
                                lineDirection="right"
                                className="floating-input"
                                value={confirmPassword}
                                onChange={(val) => setConfirmPassword(val)}
                            />
                        </div>
                    </div>
                </div>
                <div className="btn-wrap">
                    <button 
                        className="btn btn-signup btn-pink" 
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? 'Updating...' : 'Update Password'}
                    </button>
                    <div className="link-wrap">
                        <a className="signup-link" onClick={() => dispatch(removeAuthDetails())}>
                            Logout
                        </a>
                    </div>
                </div>
            </div>
        </DialogContainer>
    );
};

export default MandatoryChangePasswordModal;
